export const percentageValidation = (val: number, all: any) => {
  const isNull = Number.isNaN(val);
  if (all.acdQueueIds?.length && isNull) {
    return 'Required';
  }
  if (all.interval && !Number.isNaN(all.interval) && isNull) {
    return 'Required';
  }
  if (isNull) {
    return undefined;
  }
  return val >= 0 && val <= 1 ? undefined : 'Range 0-100';
};

export const intervalValidation = (val: number, all: any) => {
  const isNull = Number.isNaN(val);
  if (all.acdQueueIds?.length && isNull) {
    return 'Required';
  }
  if (typeof all.percentage === 'number' && !Number.isNaN(all.percentage) && isNull) {
    return 'Required';
  }
  if (isNull) {
    return undefined;
  }
  return val >= 1 && val <= 28800 ? undefined : 'Range 1-28800';
};
